export let ApprovalActions;
(function (ApprovalActions) {
  ApprovalActions["PUBLISH"] = "PUBLISH";
  ApprovalActions["MOVE_STAGE"] = "MOVE_STAGE";
  ApprovalActions["INSTALL"] = "INSTALL";
})(ApprovalActions || (ApprovalActions = {}));